export default "__VITE_ASSET__c6ef9808__"